export const SET_EXPENSE = 'SET_EXPENSE'
export const APPEND_EXPENSE = 'APPEND_EXPENSE'
export const SET_EXPENSE_CATEGORIES = 'SET_EXPENSE_CATEGORIES'
export const APPEND_EXPENSE_CATEGORIES = 'APPEND_EXPENSE_CATEGORIES'
export const SET_SHOW_EXPENSE_DETAILS = 'SET_SHOW_EXPENSE_DETAILS'
export const SET_EXPENSE_DETAILS = 'SET_EXPENSE_DETAILS'
export const SET_EXPENSE_FILTER_CATEGORY_NAME =
  'SET_EXPENSE_FILTER_CATEGORY_NAME'
